import { createFileRoute, redirect } from '@tanstack/react-router'
import { Icons } from '@journ/ui/icons'
import { useIntlayer } from 'react-intlayer'
import { login } from '@/features/auth/wiring'
import { session$ } from '@/features/auth/store'
import { resolveAuthRedirect } from '@/features/auth/domain/auth'
import { LoginForm } from '@/features/auth/ui/login-form'

export const Route = createFileRoute('/login')({
	beforeLoad: () => {
		const to = resolveAuthRedirect(session$.get(), '/login')
		if (to) throw redirect({ to })
	},
	component: LoginPage,
})

function LoginPage() {
	const navigate = Route.useNavigate()
	const content = useIntlayer('login')

	const handleSubmit = async (email: string, password: string) => {
		const result = await login({ email, password })
		if (result.success) {
			const destination = resolveAuthRedirect(result.session, '/login') ?? '/'
			await navigate({ to: destination })
		}
		return result
	}

	return (
		<div className='min-h-screen bg-background flex relative'>
			<nav className='fixed top-0 left-0 right-0 z-50 w-full pointer-events-none'>
				<div className='relative py-3 xl:py-4 px-4 xl:px-6 2xl:px-8 flex items-center'>
					<a
						href='https://journ.app'
						className='flex items-center gap-2 hover:opacity-80 transition-opacity duration-200 pointer-events-auto'
					>
						<Icons.LogoSmall className='w-6 h-6 text-foreground' />
					</a>
				</div>
			</nav>

			<div className='w-full flex flex-col justify-center items-center p-8 lg:p-12 pb-2'>
				<div className='w-full max-w-md flex flex-col h-full'>
					<div className='space-y-8 flex-1 flex flex-col justify-center'>
						<div className='text-center space-y-2'>
							<h1 className='text-lg lg:text-xl mb-4 font-serif'>{content.title}</h1>
							<p className='font-sans text-sm text-878787'>{content.subtitle}</p>
						</div>

						<LoginForm onSubmit={handleSubmit} />
					</div>

					<div className='text-center mt-auto pb-8'>
						<p className='font-sans text-xs text-878787'>
							{content.terms}{' '}
							<a
								href='https://journ.app/terms'
								className='text-878787 hover:text-foreground transition-colors underline'
							>
								{content.termsOfService}
							</a>{' '}
							{content.and}{' '}
							<a
								href='https://journ.app/policy'
								className='text-878787 hover:text-foreground transition-colors underline'
							>
								{content.privacyPolicy}
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}
